import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['channelInviteModalVisible'] = false,
  action: Action,
): RootState['channelInviteModalVisible'] {
  switch (action.type) {
    case 'CHANNEL_INVITE_MODAL_VISIBLE_SET': {
      return action.payload
    }

    default:
      return state
  }
}
